import formatContent from './formatContent';
import themeEditor from './themeEditor';

export default () => {
  formatContent();
  themeEditor();
};